import { array, bool, number, string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import MemberType from "./MemberType";

export default function CurrentlySignedUpSecondaryText({
  signupType,
  needsPayment,
  numberOfUnpaidRespondents,
  isSuggestedDonation,
  cannotModify,
  hasPaidRespondents,
  respondents,
}) {
  const isPollType = signupType === "poll";
  const isItemType = signupType === "items";

  const getSecondaryText = () => {
    if (isPollType) {
      if (needsPayment && !isSuggestedDonation) return `This vote is unpaid.`;
    } else if (isItemType) {
      if (needsPayment && hasPaidRespondents && !isSuggestedDonation) {
        return numberOfUnpaidRespondents === 1
          ? "1 item is unpaid."
          : `${numberOfUnpaidRespondents} items are unpaid.`;
      }
    } else {
      return <MemberType respondents={respondents} needsPayment={needsPayment} />;
    }
  };

  return (
    <SecondaryText data-cy="public-signup-secondary-text">
      {getSecondaryText()}
    </SecondaryText>
  );
}

CurrentlySignedUpSecondaryText.propTypes = {
  signupType: string.isRequired,
  needsPayment: bool.isRequired,
  numberOfUnpaidRespondents: number.isRequired,
  isSuggestedDonation: bool.isRequired,
  cannotModify: bool.isRequired,
  hasPaidRespondents: bool.isRequired,
  respondents: array.isRequired,
};

const SecondaryText = styled.div`
  font-size: 15px;
  color: #706d68;
  
  @media (max-width: 450px) {
    font-size: 13px;
    margin-top: 5px;
  }
`;